import script from "./MemberProfile.vue?vue&type=script&setup=true&lang=js"
export * from "./MemberProfile.vue?vue&type=script&setup=true&lang=js"

import "./MemberProfile.vue?vue&type=style&index=0&id=02f21337&lang=scss"

const __exports__ = script;

export default __exports__